import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { FunctionParametersSettingsClockWpComponent } from '../../../../P00061/Component/function-parameters-settings-clock-wp/function-parameters-settings-clock-wp.component';
import { FunctionParametersSettingClockWeekWpComponent } from '../../../../P00061/Component/function-parameters-setting-clock-week-wp/function-parameters-setting-clock-week-wp.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00062ModeFonctionnementTemperature } from '../../../Enum/P00062ModeFonctionnementTemperature';
import { P00062ModeFonctionnementRegulation } from '../../../Enum/P00062ModeFonctionnementRegulation';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';

@Component({
  selector: 'app-p00062-chauffage-parameters',
  templateUrl: './p00062-chauffage-parameters.component.html',
  styleUrls: ['./p00062-chauffage-parameters.component.scss'],
  imports: [
    LabelConfigurationComponent,
    TranslatePipe,
    SwitchConfigurationComponent,
    TwoChoicesControlComponent,
    LargedLinkComponent,
    LabelDescriptionComponent,
  ],
})
export class P00062ChauffageParametersComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private slideModalService: SlideModalController =
    inject(SlideModalController);

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {
    this.openEnSavoirPlus = this.openEnSavoirPlus.bind(this);
  }

  async openEnSavoirPlus() {
    const modal = await this.slideModalService.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description:
          'P00062.installation.parampac.modeFonctionnementRegulation.information',
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockWpComponent,
      componentProps: {
        value: [
          this.actionStack!.getValue('ppPHorlogeJourLundi'),
          this.actionStack!.getValue('ppPHorlogeJourMardi'),
          this.actionStack!.getValue('ppPHorlogeJourMercredi'),
          this.actionStack!.getValue('ppPHorlogeJourJeudi'),
          this.actionStack!.getValue('ppPHorlogeJourVendredi'),
          this.actionStack!.getValue('ppPHorlogeJourSamedi'),
          this.actionStack!.getValue('ppPHorlogeJourDimanche'),
        ],
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage3,
        'ppPHorlogeJourLundi',
        hj[0],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage4,
        'ppPHorlogeJourMardi',
        hj[1],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage5,
        'ppPHorlogeJourMercredi',
        hj[2],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage6,
        'ppPHorlogeJourJeudi',
        hj[3],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage7,
        'ppPHorlogeJourVendredi',
        hj[4],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage8,
        'ppPHorlogeJourSamedi',
        hj[5],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage9,
        'ppPHorlogeJourDimanche',
        hj[6],
      );
      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekWpComponent,
      componentProps: {
        value: this.actionStack!.getValue('ppPHorlogeSemaine'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage2,
        'ppPHorlogeSemaine',
        hj,
      );
      this.actionStack!.commit();
    }
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00062ModeFonctionnementTemperature =
    P00062ModeFonctionnementTemperature;
  protected readonly P00062ModeFonctionnementRegulation =
    P00062ModeFonctionnementRegulation;
}
